<template>
    <div :class="[{'pb-15': $vuetify.breakpoint.xsOnly}, 'pb-2']">
        <v-alert v-if="!user.uid"
                class="mt-5 mx-5 pl-8" color="primary" border="left" elevation="2"
                colored-border icon="mdi-alert">
            Vereinsdatenblätter sind nur für registrierte Benutzer sichtbar!
        </v-alert>
        <v-alert v-else-if="vereinsdatenblaetterSorted && vereinsdatenblaetterSorted.length===0"
                 class="mt-5 mx-5 pl-8" color="primary" border="left" elevation="2"
                 colored-border icon="mdi-alert">
            Es wurden keine Vereinsdatenblätter gefunden oder du bist für diese Liga nicht berechtigt!
        </v-alert>
        <div v-else>
            <v-expansion-panels class="pa-5">
                <v-expansion-panel v-for="(vereinsdatenblatt, i) in vereinsdatenblaetterSorted"
                                   :key="i">
                    <v-expansion-panel-header :disable-icon-rotate="!vereinsdatenblatt.data">
                        {{vereinsdatenblatt.vereinsName}} ({{vereinsdatenblatt.vereinsNr}})
                        <template v-slot:actions v-if="!vereinsdatenblatt.data">
                            <v-icon color="error">mdi-alert-circle</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content :class="[{'grey lighten-2': !vereinsdatenblatt.data}, 'pa-0']">
                        <div v-if="!vereinsdatenblatt.data">
                            <v-alert class="ma-0 mt-4 pl-8 body-2" color="primary" border="left" elevation="2"
                                     colored-border icon="mdi-alert-circle">
                                Es wurde noch kein Vereinsdatenblatt angelegt!
                            </v-alert>
                        </div>
                        <div v-else>
                            <vereinsdatenblatt-team :vereinsdatenblatt="vereinsdatenblatt.data"
                                small="true">
                            </vereinsdatenblatt-team>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <div v-if="atLeastOneDatenblatt">
            <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon @click="print()"
                   style="position: absolute; top: 17px; right: 65px;">
                <v-icon>mdi-printer</v-icon></v-btn>
        </div>
    </div>
</template>

<script>
    import {db} from "../../../services/db";
    import VereinsdatenblattTeam from "./vereinsdatenblattTeam";
    //import SpielService from "../../../services/data/spielService";
    export default {
        components: {VereinsdatenblattTeam},
        name: "vereinsdatenblatt-liste",
        props: ['saison'],
        computed: {
            user(){ return this.$store.state.user; },
            /*memberOfSaison(){
                const vereinsNr = this.user.permissions.spielbericht;
                if ( !vereinsNr ) {
                    return false;
                } else if ( this.saison ) {
                    const lvId = SpielService.getLvIdFromVereinsNrLong(vereinsNr);
                    const vereinId = SpielService.getVereinsNrFromVereinsNrLong(vereinsNr);
                    let reply = false;
                    Object.keys(this.saison.teams).forEach( (teamId) => {
                        if ( this.saison.teams[teamId].lvId === lvId &&
                            this.saison.teams[teamId].vereinsNr === vereinId ) {
                            console.log ("this.saison.teams[teamId]", this.saison.teams[teamId]);
                            reply = true;
                        }
                    });
                    return reply;
                } else {
                    return false;
                }
            },*/
            vereinsdatenblaetterSorted(){
                let list = this.vereinsdatenblaetter;
                list.sort((a, b) => a.vereinsName > b.vereinsName ? 1 : -1);
                return list;
            },
            atLeastOneDatenblatt(){
                return this.vereinsdatenblaetter.filter(blatt => blatt.data ).length>0;
            }
        },
        data: () => ({
            vereinsdatenblaetter: [],
        }),
        created(){
            if ( this.saison && this.vereinsdatenblaetter.length === 0 ) {
                this.getVereinsdatenBlaetter()
            }
        },
        methods: {
            getVereinsdatenBlaetter(){
                Object.keys(this.saison.teams).forEach( (teamId) => {
                    const team = this.saison.teams[teamId];
                    db.collection("vereinsdatenblaetter")
                        .doc(team.lvId + team.vereinsNr)
                        .get().then((doc) => {
                        if (doc.exists) {
                            this.vereinsdatenblaetter.push({
                                vereinsNr: doc.id,
                                vereinsName: team.vereinsName,
                                data: doc.data(),
                            })
                        } else {
                            this.vereinsdatenblaetter.push({
                                vereinsNr: team.lvId + team.vereinsNr,
                                vereinsName: team.vereinsName,
                                data: null,
                            })
                        }
                    }).catch((error) => {
                        console.log("Error getting document:", error);
                    });
                });
            },
            print(){
                this.$store.state.snapshots.vereinsdatenblaetterPrint =
                    JSON.parse(JSON.stringify(this.vereinsdatenblaetterSorted));
                let routeData = this.$router.resolve({name: 'PrintDatenblatt', query: {get: this.buildPrintQueryString()}});
                window.open(routeData.href, '_blank');
            },
            buildPrintQueryString(){
                let queryString = [];
                this.vereinsdatenblaetter.forEach( (datenblatt) => {
                    if ( datenblatt.data ) {
                        queryString.push(datenblatt.vereinsNr + datenblatt.vereinsName);
                    }
                });
                return queryString.join('_');
            }
        },
        watch: {
            saison(){
                if ( this.saison && this.vereinsdatenblaetter.length === 0 ) {
                    this.getVereinsdatenBlaetter()
                } else if ( !this.saison ) {
                    this.vereinsdatenblaetter = [];
                }
            }
        }
    }
</script>

<style scoped>

</style>